export default __webpack_public_path__ + "static/media/firmadok_login_image.fd101313.jpg";